import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class CommonMethodService {

    constructor(private toaster: ToastrService, private route: Router) {
    }

    checkFormValidOrNot(formControlName): void {
        Object.keys(formControlName.controls).forEach(field => { // {1}
            const control = formControlName.get(field);            // {2}
            control.markAsTouched({ onlySelf: true });       // {3}
          });
    }

    returnErrorMessage(error ): void {
       if ( error.status === 0) {
        this.toaster.error('Server is not reachable. Please try again!!!');
       } else if ( error.status >= 500) {
        const message = this.extractErrorMessage(error);
        this.toaster.error(message);
        console.error(error);
       } else if (error.status === 400 ) {
        const message = this.extractErrorMessage(error);
        this.toaster.error(message);
        console.error(error.error);
       } else if (error.status === 417 ) {
        const message = this.extractErrorMessage(error);
        this.toaster.error(message);
        console.error(error.error);
       } else if (error.status > 401 && error.status < 500) {
        const message = this.extractErrorMessage(error);
        this.toaster.error(message);
        console.error(error.error);
       } else if ( error.status >= 200  && error.status < 300) {
        this.toaster.success('Successfull');
        console.error('Successfull');
       } else if ( error.status === 401) {
        if ( error.error.detail === 'Bad credentials' ) {
            this.toaster.error('Invalid username or password');
        } else if ( error.error.detail === 'Full authentication is required to access this resource' ) {
            this.toaster.warning('Session has expired. Please log in again.');
        } else {
            const message = this.extractErrorMessage(error);
            this.toaster.error(message);
        }
        console.error(error.error.detail);
       } else {
        this.toaster.error('Something went wrong. Please try again latter!!!');
       }
    }

    private extractErrorMessage(error: any): string {
        if (!error || !error.error) {
            return 'Something went wrong. Please try again later.';
        }

        const errBody = error.error;

        // If error body is a Blob (responseType: 'blob'), try to read it as text
        if (errBody instanceof Blob) {
            const reader = new FileReader();
            reader.readAsText(errBody);
            // Synchronously return a fallback since FileReader is async
            return 'Something went wrong. Please try again later.';
        }

        // Backend error format: { respCode, respMessage, message, error, exception, path }
        if (errBody.respMessage && typeof errBody.respMessage === 'string') {
            return errBody.respMessage;
        }
        if (errBody.message && typeof errBody.message === 'string') {
            return errBody.message;
        }
        if (errBody.title && typeof errBody.title === 'string') {
            return errBody.title;
        }
        if (errBody.detail && typeof errBody.detail === 'string') {
            return errBody.detail;
        }

        // DRF-style or other formats
        if (typeof errBody === 'string') {
            return errBody;
        }

        // Last resort: stringify the error body
        try {
            return JSON.stringify(errBody);
        } catch (e) {
            return 'Something went wrong. Please try again later.';
        }
    }

}
